import { render, staticRenderFns } from "./r-level-track-level-pattern-table.vue?vue&type=template&id=227a7940"
import script from "./r-level-track-level-pattern-table.vue?vue&type=script&lang=js"
export * from "./r-level-track-level-pattern-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('227a7940')) {
      api.createRecord('227a7940', component.options)
    } else {
      api.reload('227a7940', component.options)
    }
    module.hot.accept("./r-level-track-level-pattern-table.vue?vue&type=template&id=227a7940", function () {
      api.rerender('227a7940', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/level-track/level/pattern/r-level-track-level-pattern-table.vue"
export default component.exports